import { render, staticRenderFns } from "./WidgetBestSpaces.vue?vue&type=template&id=2465aecd"
import script from "./WidgetBestSpaces.vue?vue&type=script&lang=js"
export * from "./WidgetBestSpaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports